<template>
  <v-dialog :value="true" persistent scrollable max-width="1000">
    <v-card>
      <v-card-title class="text-h5">Matrícula efetivada</v-card-title>
      <v-card-text>
        <p>
          A matrícula de <strong>{{ nomeDoAluno }}</strong> foi criada com a parcela de matrícula
          paga na pré-matrícula. Gere agora as mensalidades restantes, ou feche e gere depois pela
          tela de Mensalidades.
        </p>
        <v-alert type="info" outlined dense>
          A parcela de matrícula já existe, paga na pré-matrícula. Serão geradas apenas as
          mensalidades restantes.
        </v-alert>

        <v-form ref="formulario">
          <e-secao-formulario titulo="Mensalidades" icone="fa fa-calendar">
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <e-label>Valor da mensalidade *</e-label>
                <v-currency-field
                  v-model="valor_mensalidade"
                  locale="pt-BR"
                  :rules="[valorMaiorQueZero]"
                  prefix="R$"
                  required
                  dense
                  solo
                  @input="changeParcelas"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <e-label>Mês de início *</e-label>
                <v-select
                  v-model="mesInicio"
                  :items="$constants.meses"
                  item-text="descricao"
                  item-value="id"
                  return-object
                  :rules="[campoObrigatorio]"
                  dense
                  solo
                  @change="changeParcelas"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <e-label>Mês final *</e-label>
                <v-select
                  v-model="mesFinal"
                  :items="$constants.meses"
                  item-text="descricao"
                  item-value="id"
                  return-object
                  :rules="[campoObrigatorio]"
                  dense
                  solo
                  @change="changeParcelas"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <e-label>Dia de vencimento *</e-label>
                <v-text-field
                  v-model="vencimento"
                  type="number"
                  :max="31"
                  :min="1"
                  :rules="[diaObrigatorio]"
                  dense
                  solo
                  @input="changeParcelas"
                />
              </v-col>
            </v-row>
          </e-secao-formulario>
        </v-form>

        <e-secao-formulario titulo="Descontos (opcional)" icone="fa fa-percent">
          <v-row>
            <v-col cols="12" md="4">
              <e-campo-desconto
                :numero="1"
                :valor.sync="desconto_1"
                :dia.sync="descontoDia"
                @update:valor="changeParcelas"
                @update:dia="changeParcelas"
              />
            </v-col>
            <v-col cols="12" md="4">
              <e-campo-desconto
                :numero="2"
                :valor.sync="desconto_2"
                :dia.sync="descontoDia2"
                @update:valor="changeParcelas"
                @update:dia="changeParcelas"
              />
            </v-col>
            <v-col cols="12" md="4">
              <e-campo-desconto
                :numero="3"
                :valor.sync="desconto_3"
                :dia.sync="descontoDia3"
                @update:valor="changeParcelas"
                @update:dia="changeParcelas"
              />
            </v-col>
          </v-row>
        </e-secao-formulario>

        <v-data-table :headers="cabecalhos" :items="parcelas" :items-per-page="26" dense>
          <template v-slot:item.referencia="{ item: parcela }">
            {{ parcela.referencia_3 | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
          </template>
          <template v-slot:item.valor="{ item: parcela }">
            {{ parcela.valor | currency }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('fechar')">Gerar depois</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="vincularParcelas()"> Gerar parcelas </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gerarMensalidadesMixin from "@/components/Mensalidades/gerarMensalidadesMixin";
import ECampoDesconto from "@/components/Mensalidades/ECampoDesconto.vue";
import ESecaoFormulario from "./ESecaoFormulario.vue";

/**
 * Oferecido logo após a efetivação. Opcional: a parcela de matrícula já existe (veio da
 * pré-matrícula), então gera só as mensalidades. A lógica é a mesma da tela de Mensalidades
 * (mixin); só o layout muda.
 */
export default {
  name: "EModalGerarMensalidades",
  components: { ECampoDesconto, ESecaoFormulario },
  mixins: [gerarMensalidadesMixin],
  props: {
    somenteMensalidades: { type: Boolean, default: true },
  },
  computed: {
    nomeDoAluno() {
      return this.matricula.aluno ? this.matricula.aluno.nomecompleto : "aluno";
    },
  },
  methods: {
    aoGerarParcelas() {
      this.$toast.success("Mensalidades geradas.");
      this.$emit("fechar");
    },
  },
};
</script>
